import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Table, TableFilterEvent, TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { ChartModule } from "primeng/chart";
import { BCLedgerTopClientDataDto } from "../../../../../core/models/reports/bcLedgerTopClientDataDto";
import { BCLedgerTopClientMonthlyDataDto } from "../../../../../core/models/reports/bcLedgerTopClientMonthlyDataDto";
import { OrdersInvoicedDetailsRequest } from "../../../../../core/models/reports/orderBilledInvoiceDetailsRequestDto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../../shared/components/modal-stacker/modal-stacker.component";
import { ClientDetailsComponent } from "../../../../clients/components/client-details/client-details.component";
import { OrderBilledInvoicedDetailsComponent } from "../../order-billed-invoiced-details/order-billed-invoiced-details.component";
import { BCLedgerTopClientCustomSort } from "../../../../../core/models/reports/bcLedgerTopClientCustomSort";

@Component({
  selector: "jni-rpt-client-listing",
  templateUrl: "./rpt-client-listing.component.html",
  styleUrls: ["./rpt-client-listing.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    FormsModule,
    ChartModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ModalStackerComponent,
    ClientDetailsComponent,
    OrderBilledInvoicedDetailsComponent,
  ],
})
export class RptClientListingComponent implements OnChanges {
  constructor(public datepipe: DatePipe) {}
  @Input() reportData: BCLedgerTopClientDataDto[] = [];
  @Output() excelClickEvent = new EventEmitter<{
    clientName: string;
    clientAcct: string;
    sortField: string;
    sortOrder: number;
  }>();
  currentPagination = 20;
  listAfterGridFilter: BCLedgerTopClientDataDto[] = [];
  headers: string[] = [];
  showOrderBilledInvoiceReportDialog = false;
  clientAccount = "";
  @Input() dateRange = "";
  maxGpValue = 0;
  clientName = "";
  clientAcct = "";
  sortOrder = 0;
  sortField = "";
  ordersInvoicedDetailsRequest: OrdersInvoicedDetailsRequest =
    {} as OrdersInvoicedDetailsRequest;
  filterFromDate = "";
  filterToDate = "";
  showClientSummaryDialog = false;

  ngOnChanges(changes: SimpleChanges) {
    if (changes["reportData"]) {
      this.generateHeaders();
    }
  }

  onSortEvent(event: BCLedgerTopClientCustomSort) {
    const meta = event?.multisortmeta?.[0];
    this.sortField = meta?.field ?? "";
    this.sortOrder = meta?.order ?? 0;
  }

  onFilter(event: TableFilterEvent, dt: Table) {
    this.currentPagination = dt._rows ?? 0;
    if (event?.filters && event?.filteredValue?.length > 0) {
      this.listAfterGridFilter = event.filteredValue;
    } else {
      this.listAfterGridFilter = [];
    }
  }

  lastPageStatus = true;
  setMyPagination(dt: Table) {
    this.currentPagination = dt._rows ?? 0;
    const pageDiff = dt._totalRecords - (dt._first ?? 0);
    if (pageDiff <= (dt._rows ?? 0)) {
      this.lastPageStatus = false;
    } else this.lastPageStatus = true;
  }

  generateHeaders() {
    if (this.reportData.length > 0 && this.reportData[0].Data) {
      this.headers = this.reportData[0].Data.map(
        data =>
          new Date(data.TimeFrame).getFullYear() +
          "/" +
          (new Date(data.TimeFrame).getMonth() + 1)
      );

      this.maxGpValue = Math.max(...this.reportData.map(o => o.MonthWiseGP));
    }
  }

  openOrderBilledInvoiceReportModal(clientAccount: string) {
    this.clientAccount = clientAccount;
    this.ordersInvoicedDetailsRequest.customerAccountD365 = clientAccount;
    this.ordersInvoicedDetailsRequest.isAdditionalFilters = true;
    this.ordersInvoicedDetailsRequest.invoiceDateFrom = this.filterFromDate;
    this.ordersInvoicedDetailsRequest.invoiceDateTo = this.filterToDate;
    this.showOrderBilledInvoiceReportDialog = true;
  }

  closeOrderBilledInvoiceReportModal() {
    this.showOrderBilledInvoiceReportDialog = false;
  }

  openClientSummaryModal(clientAccount: string) {
    this.clientAccount = clientAccount;
    this.showClientSummaryDialog = true;
  }

  closeClientSummaryModal() {
    this.showClientSummaryDialog = false;
  }

  openOrderBilledInvoiceReportModalWithSpecificMonth(
    clientAccount: string,
    data: BCLedgerTopClientMonthlyDataDto
  ) {
    this.clientAccount = clientAccount;
    this.ordersInvoicedDetailsRequest.customerAccountD365 = clientAccount;
    this.ordersInvoicedDetailsRequest.isAdditionalFilters = true;
    this.ordersInvoicedDetailsRequest.invoiceDateFrom = data.TimeFrame;
    const endDate = new Date(data.TimeFrame);
    const endDateWithLastDay = new Date(
      endDate.getFullYear(),
      endDate.getMonth() + 1,
      0
    );
    this.ordersInvoicedDetailsRequest.invoiceDateTo =
      this.transformDateFormat(endDateWithLastDay) ?? "";
    this.showOrderBilledInvoiceReportDialog = true;
  }

  transformDateFormat(date: Date) {
    return this.datepipe.transform(date, "yyyy-MM-ddTHH:mm:ss");
  }

  exportExcel() {
    this.excelClickEvent.emit({
      clientName: this.clientName,
      clientAcct: this.clientAcct,
      sortField: this.sortField,
      sortOrder: this.sortOrder,
    });
  }

  getDateRangeString() {
    if (this.dateRange === "Last 12 Months") {
      return "12 MO";
    } else if (this.dateRange === "Current Calendar Year") {
      return "CYD";
    } else if (this.dateRange === "Last Calendar Year") {
      return "LYD";
    } else if (this.dateRange === "Current Fiscal Year") {
      return "FYD";
    }
    return "";
  }

  setMainFilter(fromDate: string, toDate: string) {
    this.filterFromDate = fromDate;
    this.filterToDate = toDate;
  }
}
